import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { PatientType } from '../lib/context/ManagePatientContext';
import useApi from './useApi';

type Api = ReturnType<typeof useApi>['Api'];

export const patientByIdQueryOptions = (Api: Api, patientId?: string) => ({
  queryKey: ['patientDetails', patientId],
  queryFn: async (): Promise<PatientType | null> => {
    const response = await Api.referrers.getPatient(patientId);

    return response?.data?.users?.[0] ?? null;
  }
});

const usePatientByIdQuery = (patientId?: string): UseQueryResult<PatientType | null> => {
  const { Api } = useApi();

  return useQuery({
    ...patientByIdQueryOptions(Api, patientId),
    enabled: !!patientId
  });
};

export const useEnsurePatientById = () => {
  const { Api } = useApi();
  const queryClient = useQueryClient();

  return (patientId: string) => queryClient.ensureQueryData(patientByIdQueryOptions(Api, patientId));
};

export default usePatientByIdQuery;
